import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
} from './ui/breadcrumb';
import { EClaimType, TPath } from '../lib/types';
import { Link, useSearch } from '@tanstack/react-router';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { ChevronDownIcon } from 'lucide-react';
import { refundOptionsArray } from '../lib/constants';
import { cn } from '../lib/utils';
import { useQuery } from '@tanstack/react-query';
import { getFacilityPaymentSettings } from '../services/payment-settings';
import { useTranslation } from 'react-i18next';

const RefundOptionBreadcrumb = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  const homeUrl: TPath = '/payments/payment-methods';
  const search = useSearch({
    strict: false,
  });

  const facilityPaymentSettings = useQuery({
    queryKey: ['facilityPaymentSettings', search.entityType],
    queryFn: getFacilityPaymentSettings,
  });

  return (
    <Breadcrumb className={cn(className)}>
      <BreadcrumbList className='text-muted-foreground'>
        <BreadcrumbItem>
          <Link
            to={homeUrl}
            search={(prev: Record<string, unknown>) => ({
              ...prev,
              paymentType: undefined,
              step: 1,
            })}
          >
            {t('Select Payment Type')}
          </Link>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        {search.paymentType && (
          <>
            <BreadcrumbItem>
              <DropdownMenu>
                <DropdownMenuTrigger className='flex items-center gap-1'>
                  {t(search.paymentType?.replace('+', ' '))}
                  <ChevronDownIcon className='w-4' />
                </DropdownMenuTrigger>
                <DropdownMenuContent align='start'>
                  {refundOptionsArray
                    .filter(
                      (option) =>
                        search.claimType &&
                        search.paymentType !== option.title &&
                        option.allowFor.includes(search.claimType) &&
                        facilityPaymentSettings.data?.[
                          search.claimType === EClaimType.EMAIL
                            ? 'emailPaymentMethods'
                            : 'letterPaymentMethods'
                        ].includes(option.refundMethod),
                    )
                    .map((option) => (
                      <DropdownMenuItem key={t(option.title)}>
                        <Link
                          to={option.path}
                          search={(prev: Record<string, unknown>) => ({
                            ...prev,
                            paymentType: option.title,
                            step: 2,
                          })}
                          className='flex items-center gap-1'
                        >
                          {t(option.title)}
                        </Link>
                      </DropdownMenuItem>
                    ))}
                </DropdownMenuContent>
              </DropdownMenu>
            </BreadcrumbItem>
          </>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default RefundOptionBreadcrumb;
